import api from './api'
export const getWorkerAssignmentReadiness = async (assignmentId: string, tenantId: string, signal: AbortSignal): Promise<unknown> =>
  (await api.get(`/api/job-assignments/${encodeURIComponent(assignmentId)}/readiness`, { signal, headers: { 'x-tenant-id': tenantId } })).data
